import { css } from '@emotion/css';

export const aiRecommendedBorderClass = css`
  background: linear-gradient(135deg, #5b21b6, #ec4899, #a78bfa);
  background-size: 300% 300%;
  padding: 2px;
  border-radius: 10px;
  overflow: hidden;
  animation: borderMove 3s ease-in-out infinite;
  width: 100%;
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.3);
  }

  @keyframes borderMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
